export default "__VITE_ASSET__DxuyL3qR__"